import classNames from "classnames";
import Button from "components/Button";
import React, { useEffect, useRef, useState } from "react";
import { Icon } from "./Icon";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  modalHeader: string | React.ReactNode;
  children: React.ReactNode;
  modalBodyClassName?: string;
  modalHeaderClassName?: string;
  modalHeaderTitleClassName?: string;
  customModalStyles?: object;
  modalContentClassName?: string;
  modalContainerClassName?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  className = "",
  children,
  modalHeader,
  modalBodyClassName,
  modalHeaderClassName,
  customModalStyles,
  modalContentClassName,
  modalHeaderTitleClassName,
  modalContainerClassName,
}) => {
  const [animation, setAnimation] = useState("");
  const [modalHeight, setModalHeight] = useState(0);
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen) {
      setAnimation("animate-slideUp");
      if (modalRef.current) {
        setModalHeight(modalRef.current.clientHeight);
      }
    } else {
      setAnimation("animate-slideDown");
    }
  }, [isOpen]);

  if (!isOpen && animation === "animate-slideDown") return null;

  return (
    <div
      className={classNames(
        `fixed inset-0 z-50 flex ${modalHeight > 500 ? "items-start" : "items-center"} justify-center overflow-auto outline-none focus:outline-none bg-black bg-opacity-40 shadow animate-opacityAnimation`,
        modalContainerClassName
      )}
    >
      <div
        className={`relative z-60 w-auto mx-2 md:mx-auto my-6  ${animation}`}
      >
        <div
          className={`modal ${className} bg-white rounded-md`}
          ref={modalRef}
          style={{ ...customModalStyles }}
        >
          <div
            className={classNames("modal-content pt-4", modalContentClassName)}
          >
            {modalHeader && (
              <div
                className={classNames(
                  "modal-header flex justify-between items-center px-5",
                  modalHeaderClassName
                )}
              >
                <h3
                  className={classNames(
                    "text-gray-900 text-lg font-semibold mt-4",
                    modalHeaderTitleClassName
                  )}
                >
                  {modalHeader}
                </h3>
              </div>
            )}
            <Button
              className="absolute right-2 top-2 !p-2 space-x-1"
              aria-label="Close"
              onClick={onClose}
              variant="gray"
            >
              <span className="text-sm leading-5 font-semibold">Close</span>
              <Icon name="close" />
            </Button>
            <div
              className={classNames("modal-body mt-5", modalBodyClassName)}
              style={{ ...customModalStyles }}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
